import { DefaultUrlSerializer, UrlTree } from '@angular/router';

// The router matches route paths case-sensitively while varnish keys its cache on the lowercased url,
// so /Tags/x (links around the web) rendered the 404 page and that page was then served for /tags/x too.
// Lowercase the top-level segment only - tag slugs and ids below it stay case-sensitive.
export class LowercaseRouteUrlSerializer extends DefaultUrlSerializer {
    override parse(url: string): UrlTree {
        return super.parse(url.replace(/^(\/?)([^/?#;(]+)/, (_match, slash: string, first: string) => slash + first.toLowerCase()));
    }
}
